import { render, staticRenderFns } from "./BaseOverlay.vue?vue&type=template&id=4639b67e&scoped=true&"
import script from "./BaseOverlay.vue?vue&type=script&lang=js&"
export * from "./BaseOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BaseOverlay.vue?vue&type=style&index=0&id=4639b67e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4639b67e",
  null
  
)

export default component.exports